'use client';

import React from 'react';
import { useIsFirstRender } from './useIsFirstRender';

export const useRefFunction = <T extends unknown>(initVal: () => T): React.MutableRefObject<T> => {
  const firstRender = useIsFirstRender();
  const val = React.useRef<T>(null as unknown as T);
  if (firstRender) {
    val.current = initVal();
  }
  return val as React.MutableRefObject<T>;
};
